import dom from "react-dom";
import "./index.css";
import App from "./app";
import React from "react";

dom.render(<App />, document.getElementById("root"));
